// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggler_container__jrrWx","header":"Toggler_header__HcEWk","emoji":"Toggler_emoji__4ZaQN","contentContainer":"Toggler_contentContainer__a33H2"};